const mocks = {
  subscribe: jest.fn().mockReturnValue({}),

  gtmOnSystemError: jest.fn().mockReturnValue({}),

  preloadSdk: jest.fn().mockReturnValue({
    preloadSdk: () => true
  }),

  destroySdk: jest.fn().mockReturnValue({
    destroySdk: () => true
  }),

  ga4AppCompleted: jest.fn().mockReturnValue({})
};

export default mocks;
